import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    const handleMouseMove = (e) => setPosition({ x: e.clientX, y: e.clientY });
    const handleMouseOver = (e) => { if (e.target.closest('button, a, [data-cursor-hover]')) setIsHovering(true); };
    const handleMouseOut = (e) => { if (e.target.closest('button, a, [data-cursor-hover]')) setIsHovering(false); };

    window.addEventListener('mousemove', handleMouseMove);
    document.addEventListener('mouseover', handleMouseOver);
    document.addEventListener('mouseout', handleMouseOut);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseover', handleMouseOver);
      document.removeEventListener('mouseout', handleMouseOut);
    };
  }, []);

  return (
    <motion.div
      className="fixed pointer-events-none z-[10000] mix-blend-difference hidden md:block"
      animate={{
        x: position.x - (isHovering ? 25 : 8),
        y: position.y - (isHovering ? 25 : 8),
        width: isHovering ? 50 : 16,
        height: isHovering ? 50 : 16,
      }}
      transition={{ type: 'spring', damping: 30, stiffness: 200 }}
      style={{ backgroundColor: '#C97A2B', borderRadius: '50%' }}
    />
  );
};

export default CustomCursor;
